import { useState, useEffect } from "react";
import { ClassOption } from "../views/components/LabelPropagation/types";
import { composeApiURL } from "../helpers/utility/axiosHelpers";
import axios from "axios";

export const useDatasetClassesOptions = (
  datasetId: string,
): { data: ClassOption[]; loading: boolean; error: any } => {
  const [data, setData] = useState<ClassOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  type RawClassResponse = Record<string, string>;

  useEffect(() => {
    const fetchData = async () => {
      const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;
      const url = composeApiURL(HOST_URL, `/label_category/${datasetId}`);

      try {
        const response = await axios.get<RawClassResponse>(url);
        setData(
          Object.entries(response.data).map(([value, label]) => ({
            value,
            label,
          })),
        );
      } catch (e) {
        setError(e);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [datasetId]);

  return { data, loading, error };
};
